// https://coolors.co/47e5bc-2b59c3-c6d4ff-7b0828-252323

export const COLOURS = { 
  PRIMARY :   '#2B59C3', // tang blue
  SECONDARY : '#47E5BC', // aquamarine
  TERTIARY:   '#C6D4FF', // periwinkle

  WARNING:    '#7B0828', // Claret
  ALERT:      '#FCAA67',
  SUCCESS:    '#3f8600',

  NO_DATA:    '#f1f4ff80',

  BLACK :     '#252323', // Raisin Black
  WHITE:      'white',

  BACKGROUND: '#F1F4FF'
}